module.exports = __webpack_public_path__ + "public/img/avatar.1eecaeca.svg";